import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertAuthorityClaimMutationVariables = Types.Exact<{
  object: Types.Authority_Claims_Insert_Input;
}>;


export type InsertAuthorityClaimMutation = { __typename?: 'mutation_root', insert_authority_claims_one?: { __typename?: 'authority_claims', id: any } | null };


export const InsertAuthorityClaimDocument = gql`
    mutation InsertAuthorityClaim($object: authority_claims_insert_input!) {
  insert_authority_claims_one(object: $object) {
    id
  }
}
    `;
export type InsertAuthorityClaimMutationFn = Apollo.MutationFunction<InsertAuthorityClaimMutation, InsertAuthorityClaimMutationVariables>;

/**
 * __useInsertAuthorityClaimMutation__
 *
 * To run a mutation, you first call `useInsertAuthorityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAuthorityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAuthorityClaimMutation, { data, loading, error }] = useInsertAuthorityClaimMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertAuthorityClaimMutation(baseOptions?: Apollo.MutationHookOptions<InsertAuthorityClaimMutation, InsertAuthorityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAuthorityClaimMutation, InsertAuthorityClaimMutationVariables>(InsertAuthorityClaimDocument, options);
      }
export type InsertAuthorityClaimMutationHookResult = ReturnType<typeof useInsertAuthorityClaimMutation>;
export type InsertAuthorityClaimMutationResult = Apollo.MutationResult<InsertAuthorityClaimMutation>;
export type InsertAuthorityClaimMutationOptions = Apollo.BaseMutationOptions<InsertAuthorityClaimMutation, InsertAuthorityClaimMutationVariables>;